import { NextPage } from 'next'

import Carousel from 'components/carousel'
import HomePageLayout from '~ui/Layouts/HomePageLayout'
import { NeonCard } from '~ui'
import { GRANTED_REWARDS, REWARDS_JOIN } from 'routes/paths'
import { REWARD_FAQ } from 'routes/external'
import Tickets from 'components/tickets'
import Icon, { IconTypes } from '~ui/Icon'
import { MetaTags } from '~shared'
import { useUser } from '~hooks'
import { useVariables } from 'hooks/useVariables'

import { ReactNode } from 'react'
import Link from 'next/link'

type MenuItems = {
  index: number
  name: ReactNode
  value: ReactNode
  icon: ReactNode
  creditTypeName?: string
}

const menuItems: MenuItems[] = [
  {
    index: 1,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        fill="#737373"
        height="1em"
        width="1em"
      >
        <circle cx="256" cy="128" r="128" />
        <path d="M256 298.667c-105.99.118-191.882 86.01-192 192C64 502.449 73.551 512 85.333 512h341.333c11.782 0 21.333-9.551 21.333-21.333-.117-105.99-86.009-191.883-191.999-192z" />
      </svg>
    ),
    name: 'Create an account',
    value: 'Earn ${} Credit',
    creditTypeName: 'sign_up',
  },
  {
    index: 2,
    icon: (
      <svg
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        fill="#737373"
        viewBox="0 0 24 24"
      >
        <path d="M7.5 13A4.5 4.5 0 1 1 12 8.5 4.505 4.505 0 0 1 7.5 13zM14 24H1a1 1 0 0 1-1-1v-.5a7.5 7.5 0 0 1 15 0v.5a1 1 0 0 1-1 1zm3.5-15A4.5 4.5 0 1 1 22 4.5 4.505 4.505 0 0 1 17.5 9zm-1.421 2.021a6.825 6.825 0 0 0-4.67 2.831A9.537 9.537 0 0 1 16.323 19H23a1 1 0 0 0 1-1v-.038a7.008 7.008 0 0 0-7.921-6.941z" />{' '}
      </svg>
    ),
    name: (
      <>
        Refer a friend<sup>*</sup>
      </>
    ),
    value: 'Earn ${} Credit',
    creditTypeName: 'referral',
  },
  {
    index: 3,
    icon: (
      <svg viewBox="0 0 22 22" fill="none" height="1em" width="1em">
        <path
          stroke="#737373"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12.716 9.285a4.853 4.853 0 0 0-6.862 0l-3.433 3.43a4.853 4.853 0 0 0 6.864 6.864L11 17.863"
        />
        <path
          stroke="#737373"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.284 12.716a4.853 4.853 0 0 0 6.862 0l3.432-3.431a4.853 4.853 0 1 0-6.863-6.864L11 4.137"
        />
      </svg>
    ),
    name: 'Signing up from a referral',
    value: 'Earn ${} Credit',
    creditTypeName: 'joined_from_referral',
  },
  {
    index: 4,
    icon: (
      <svg
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#737373"
      >
        <path d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0Zm-1.356 10.76 3.041.507A2.761 2.761 0 0 1 16 14c0 1.654-1.346 3-3 3v2h-2v-2c-1.654 0-3-1.346-3-3h2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1 .768.768 0 0 0-.644-.76l-3.041-.507A2.761 2.761 0 0 1 8 10c0-1.654 1.346-3 3-3V5h2v2c1.654 0 3 1.346 3 3h-2c0-.551-.448-1-1-1h-2c-.552 0-1 .449-1 1 0 .378.271.698.644.76Z" />{' '}
      </svg>
    ),
    name: 'Every order after your first',
    value: 'Earn ${} Credit',
    creditTypeName: 'order_placed_reward',
  },
  {
    index: 5,
    icon: (
      <svg
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#737373"
      >
        <path d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0Zm-1.356 10.76 3.041.507A2.761 2.761 0 0 1 16 14c0 1.654-1.346 3-3 3v2h-2v-2c-1.654 0-3-1.346-3-3h2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1 .768.768 0 0 0-.644-.76l-3.041-.507A2.761 2.761 0 0 1 8 10c0-1.654 1.346-3 3-3V5h2v2c1.654 0 3 1.346 3 3h-2c0-.551-.448-1-1-1h-2c-.552 0-1 .449-1 1 0 .378.271.698.644.76Z" />{' '}
      </svg>
    ),
    name: 'Exclusive discounts',
    value: <Icon name="checked" />,
  },
  {
    index: 6,
    icon: (
      <svg
        height="1em"
        width="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.1665 17.5C9.1665 17.1685 9.03481 16.8505 8.80039 16.6161C8.56597 16.3817 8.24802 16.25 7.9165 16.25C7.58498 16.25 7.26704 16.3817 7.03262 16.6161C6.7982 16.8505 6.6665 17.1685 6.6665 17.5H2.49984C2.27882 17.5 2.06686 17.4122 1.91058 17.2559C1.7543 17.0996 1.6665 16.8877 1.6665 16.6667V3.33333C1.6665 3.11232 1.7543 2.90036 1.91058 2.74408C2.06686 2.5878 2.27882 2.5 2.49984 2.5H6.6665C6.6665 2.83152 6.7982 3.14946 7.03262 3.38388C7.26704 3.6183 7.58498 3.75 7.9165 3.75C8.24802 3.75 8.56597 3.6183 8.80039 3.38388C9.03481 3.14946 9.1665 2.83152 9.1665 2.5H17.4998C17.7209 2.5 17.9328 2.5878 18.0891 2.74408C18.2454 2.90036 18.3332 3.11232 18.3332 3.33333V7.91667C17.7806 7.91667 17.2507 8.13616 16.86 8.52686C16.4693 8.91756 16.2498 9.44747 16.2498 10C16.2498 10.5525 16.4693 11.0824 16.86 11.4731C17.2507 11.8638 17.7806 12.0833 18.3332 12.0833V16.6667C18.3332 16.8877 18.2454 17.0996 18.0891 17.2559C17.9328 17.4122 17.7209 17.5 17.4998 17.5H9.1665ZM7.9165 8.75C8.24802 8.75 8.56597 8.6183 8.80039 8.38388C9.03481 8.14946 9.1665 7.83152 9.1665 7.5C9.1665 7.16848 9.03481 6.85054 8.80039 6.61612C8.56597 6.3817 8.24802 6.25 7.9165 6.25C7.58498 6.25 7.26704 6.3817 7.03262 6.61612C6.7982 6.85054 6.6665 7.16848 6.6665 7.5C6.6665 7.83152 6.7982 8.14946 7.03262 8.38388C7.26704 8.6183 7.58498 8.75 7.9165 8.75ZM7.9165 13.75C8.24802 13.75 8.56597 13.6183 8.80039 13.3839C9.03481 13.1495 9.1665 12.8315 9.1665 12.5C9.1665 12.1685 9.03481 11.8505 8.80039 11.6161C8.56597 11.3817 8.24802 11.25 7.9165 11.25C7.58498 11.25 7.26704 11.3817 7.03262 11.6161C6.7982 11.8505 6.6665 12.1685 6.6665 12.5C6.6665 12.8315 6.7982 13.1495 7.03262 13.3839C7.26704 13.6183 7.58498 13.75 7.9165 13.75Z"
          fill="#737373"
        />
      </svg>
    ),
    name: 'Early access',
    value: <Icon name="checked" />,
  },
]

export const RewardsMenu = () => {
  const { CREDIT_ACTION_TYPES } = useVariables()

  return (
    <div className="widget">
      <div className="py-4 px-6 border-b border-g-dividers">
        <h2 className="uppercase text-lg text-white tracking-widest glow-text-g-yellow">
          granted rewards benefits
        </h2>
      </div>
      <div className="px-6">
        <ul>
          {menuItems.map(({ index, name, value, icon, creditTypeName = undefined }) => (
            <li
              className="border-b border-g-dividers last:border-b-0 py-4 flex justify-between space-x-4"
              key={index}
            >
              <div className="flex items-center text-white space-x-4">
                <span>{icon}</span>
                <span>{name}</span>
              </div>
              <div className="text-white text-end">
                {typeof value === 'string'
                  ? value.replace(/{}/g, `${CREDIT_ACTION_TYPES[creditTypeName]}`)
                  : value}
              </div>
            </li>
          ))}
        </ul>

        <div className="py-6 text-sm text-g-light-gray border-t border-g-dividers">
          <sup>*</sup>Credit will be applied when referral places first order.
        </div>
      </div>
    </div>
  )
}

const Rewards: NextPage = () => {
  const [user] = useUser()

  return (
    <>
      <MetaTags title="Rewards" />
      <HomePageLayout>
        <div className="space-y-12 md:space-y-16">
          <Tickets
            icon="granted-rewards-logo"
            description={
              <div className="flex flex-col max-w-4xl">
                <p className="text-center mb-6">
                  Granted is the only platform that gives you account credit on every purchase.
                  Create a free account to become a rewards member and start earning cash back on
                  all your favorite live events!
                </p>
                <Link legacyBehavior href={user ? GRANTED_REWARDS : REWARDS_JOIN}>
                  <a className="btn btn-g-yellow btn-lg self-center">Start earning</a>
                </Link>
              </div>
            }
            backgroundImage="url(https://img.granted.co/1666946510202-rewards.png)"
            title="Granted Rewards"
            color="yellow"
            iconProps={{ height: null }}
          />

          <div className="px-4 max-w-2xl mx-auto w-full">
            <RewardsMenu />
          </div>

          <div className="max-w-6xl mx-auto md:px-4">
            <Carousel
              maxItemsToShow={3}
              dataSource={[
                {
                  title: 'Create an account',
                  colorGlow: 'neon-purple',
                  iconName: 'granted-rewards-create-account',
                  description:
                    "Creating an account takes 30 seconds and allows you to start earning account credit on every purchase. You'll also unlock perks like early access, discounts, and more!",
                },
                {
                  title: 'ACCOUNT CREDIT',
                  colorGlow: 'red',
                  iconName: 'credit-card-thin',
                  description:
                    'Earn cash (account credit) on every purchase. Account credit NEVER expires and is useable for any concerts, comedy and sports event on Granted.',
                },
                {
                  title: 'REFER Family & Friends',
                  colorGlow: 'red',
                  iconName: 'user-thin',
                  description: `You get a personal link to invite family and friends to Granted. They get credit for joining through your link and you get credit after they sign up!`,
                },
                {
                  title: 'EXCLUSIVE DISCOUNTS',
                  colorGlow: 'orange',
                  iconName: 'discount-badge-thin',
                  description:
                    'Every month, rewards members get exclusive discounts. Offers include bonus account credit, promo codes, and more.',
                },
                {
                  title: 'EARLY ACCESS',
                  colorGlow: 'yellow',
                  iconName: 'calendar-check-thin',
                  description:
                    "Be the first to know about Granted exclusive VIP tours, suite access at stadium venues and experiences money can't buy.",
                },
              ]}
              renderItem={({ title, colorGlow, description, iconName }) => (
                <NeonCard
                  key={title}
                  colorGlow={colorGlow as GThemeColorsNew}
                  description={description}
                  title={title}
                  iconName={iconName as IconTypes}
                />
              )}
            />
          </div>

          <div className="px-4 max-w-2xl mx-auto w-full">
            <div className="flex flex-col px-4 py-6 border border-white glow-box-primary glow-box-opacity-40">
              <h2 className="uppercase text-center mb-4 glow-text-primary text-2xl">
                Got questions?
              </h2>
              <a
                className="btn btn-stroke-primary self-center"
                rel="noreferrer"
                target="_blank"
                type="button"
                href={REWARD_FAQ}
              >
                Visit our faq
              </a>
            </div>
          </div>
        </div>
      </HomePageLayout>
    </>
  )
}

export default Rewards
